/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { checkAuthentication } from '@jira/spa-apps__interceptors/src/checkAuthentication.tsx';
// eslint-disable-next-line jira/import-whitelist
import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
// eslint-disable-next-line jira/import-whitelist
import { getCmdbObjectByIdUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getCmdbObjectQueryLanguageUrl.tsx';
// eslint-disable-next-line jira/import-whitelist
import fetchWorkspaceId from '@jira/servicedesk__insight-common-services-workspace-context/src/fetchWorkspaceId.tsx';
import type { InsightObjectDetailsResponse } from '@jira/servicedesk__insight-common-types-object-types/src/TypesOpsgenieTeam.tsx';
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import logger from '@atlassian/jira-common-util-logging/src/log.tsx';

import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
// eslint-disable-next-line jira/import-whitelist
import { prefetchApiReadyMark } from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';

import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';

const fetchInsightObjectDetails = async (
	routeDataContext: RouterDataContext,
	storeContext: ResourceStoreContext,
): Promise<InsightObjectDetailsResponse | null> => {
	try {
		const {
			match: { params },
		} = routeDataContext;
		const { objectId } = params;

		if (objectId == null) {
			return null;
		}

		const workspaceId = await fetchWorkspaceId(routeDataContext, storeContext);
		if (workspaceId == null) {
			return null;
		}

		const data: InsightObjectDetailsResponse = await fetchJson(
			getCmdbObjectByIdUrl(workspaceId, objectId),
		);
		setMark(prefetchApiReadyMark);

		return data;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		logger.safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
		fireCmdbErrorAnalytics({
			meta: {
				id: 'jiraServicedeskInsightObjectResource',
				packageName: 'jiraSpa',
			},
			error,
		});
		throw error;
	}
};

const getData = async (
	routeDataContext: RouterDataContext,
	storeContext: ResourceStoreContext,
): Promise<InsightObjectDetailsResponse | null> => {
	const { tenantContext } = storeContext;

	// Early exit on these cases and return a valid response. We don't want to flood sentry.
	if (!checkAuthentication(tenantContext)) {
		throw createResourceError({
			component: 'spa.view.routes.servicedesk.cmdb-object.getData',
			message: 'Current user is not authenticated',
			name: 'AuthenticationError',
			skipSentry: true,
		});
	}

	return fetchInsightObjectDetails(routeDataContext, storeContext);
};

export default getData;
